<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import SalesReviewReturnHeader from './SalesReviewReturnHeader.vue';

const props = defineProps({
  canSubmit: { type: Boolean, default: false },
  isCorrection: { type: Boolean, default: false },
  readOnly: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
  transaction: { type: Object, default: null },
});
const emit = defineEmits(['back', 'submit']);
const { t } = useI18n();

const title = computed(() =>
  props.isCorrection ? t('SALES.REVIEW.TITLE') : t('SALES.REVIEW.RETURN_TITLE')
);
const subtitle = computed(() =>
  props.isCorrection
    ? t('SALES.REVIEW.SUBTITLE')
    : t('SALES.REVIEW.RETURN_SUBTITLE')
);
</script>

<template>
  <LaisHeader
    v-if="isCorrection || !transaction"
    :title="title"
    :subtitle="subtitle"
    :breadcrumb="[{ label: t('SALES.TITLE') }, { label: title }]"
    show-back
    :back-label="t('SALES.ACTIONS.BACK')"
    @back="emit('back')"
  >
    <template #actions>
      <LaisPrimaryButton
        v-if="canSubmit && isCorrection"
        :is-loading="saving"
        icon="i-lucide-send"
        @click="emit('submit')"
      >
        {{ t('SALES.REVIEW.ACTIONS.RESUBMIT') }}
      </LaisPrimaryButton>
    </template>
  </LaisHeader>
  <SalesReviewReturnHeader
    v-else
    :read-only="readOnly"
    :transaction="transaction"
    @back="emit('back')"
  />
</template>
